export default {
	SET_COMMON_PAYLOAD: "SET_COMMON_PAYLOAD",
	RESET: "RESET",
}
